import React, { useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { Navigation } from "../components/navigation";
import BeforeAfter from "../components/BeforeAfter";
import BeforeAfter2 from "../components/BeforeAfter2";
import BeforeAfter3 from "../components/BeforeAfter3";
import ProjectCard from "../components/ProjectCard";
import "./ServicePage.css";

// Import all images
import img10 from '../images/10.jpeg';
import img11 from '../images/11.jpeg';
import img12 from '../images/12.jpeg';
import img13 from '../images/13.jpeg';
import img14 from '../images/14.jpeg';
import img15 from '../images/15.jpeg';
import img16 from '../images/16.jpeg';
import img17 from '../images/17.jpeg';
import img22 from '../images/22.jpeg';
import img18 from '../images/18.jpeg';
import img19 from '../images/19.jpeg';
import img20 from '../images/20.jpeg';
import img21 from '../images/21.jpeg';
import img23 from '../images/23.jpeg';
import img24 from '../images/24.jpeg';
import img25 from '../images/25.jpeg';
import img26 from '../images/26.jpeg';
import img27 from '../images/27.jpeg';
import img28 from '../images/28.jpeg';
import img29 from '../images/29.jpeg';
import img30 from '../images/30.jpeg';
import img31 from '../images/31.jpeg';
import img32 from '../images/32.jpeg';
import img33 from '../images/33.jpeg';
import img34 from '../images/34.jpeg';
import img35 from '../images/35.jpeg';
import img36 from '../images/36.jpeg';
import img37 from '../images/37.jpeg';
import img38 from '../images/38.jpeg';
import img39 from '../images/39.jpeg';
import img40 from '../images/40.jpeg';
import img41 from '../images/41.jpeg';
import img42 from '../images/42.jpeg';
import img43 from '../images/43.jpeg';
import img44 from '../images/44.jpeg';
import img45 from '../images/45.jpeg';
import img46 from '../images/46.jpeg';
import img47 from '../images/47.jpeg';
import img48 from '../images/48.jpeg';
import img49 from '../images/49.jpeg';
import img50 from '../images/50.jpeg';
import img51 from '../images/51.jpeg';
import img52 from '../images/52.jpeg';
import img53 from '../images/53.jpeg';
import img54 from '../images/54.jpeg';
import img55 from '../images/55.jpeg';
import img56 from '../images/56.jpeg';
import img57 from '../images/57.jpeg';
import img58 from '../images/58.jpeg';
import img59 from '../images/59.jpeg';
import img60 from '../images/60.jpeg';
import img61 from '../images/61.jpeg';
import img62 from '../images/62.jpeg';
import img1 from '../images/1.jpeg';
import img2 from '../images/2.jpeg';
import img3 from '../images/3.jpeg';
import img4 from '../images/4.jpeg';
import img5 from '../images/5.jpeg';
import img6 from '../images/6.jpeg';
import img8 from '../images/8.jpeg';
import construction1 from '../construction2.png';
import construction2 from '../construction3.png';
import img63 from '../images/63.jpeg';
import img64 from '../images/64.jpeg';
import img65 from '../images/65.jpeg';
import img66 from '../images/66.jpeg';
import img67 from '../images/67.jpg';
import img68 from '../images/68.jpg';
import img69 from '../images/69.jpg';
import img70 from '../images/70.jpg';
import img71 from '../images/71.jpg';
import img72 from '../images/72.jpg';
import img73 from '../images/73.jpg';
import img74 from '../images/74.jpg';
import img75 from '../images/75.jpg';
import img76 from '../images/76.jpg';
import img77 from '../images/77.jpg';
import img78 from '../images/78.jpg';
import img79 from '../images/79.jpg';
import img80 from '../images/80.jpg';
import img81 from '../images/81.jpg';
import { Contact2 } from "../components/Contact2";

// Service images mapping
const serviceImages = {
  "Salle de bain clé en main": [
    { type: 'BeforeAfter2', props: { i1: img10, i2: img11, i3: img12, title: "Renovation Salle de Bain" } },
    { type: 'BeforeAfter', props: { i1: img16, i2: img17, title: "Renovation Salle de Bain" } },
    { type: 'ProjectCard', props: { images: [img23, img24, img25, img26], title: "Renovation Salle de Bain" } },
    { type: 'ProjectCard', props: { images: [img30, img31, img32, img33, img34], title: "Renovation Salle de Bain" } }
  ],
  "Ravalement de façade": [
    { type: 'ProjectCard', props: { images: [img13, img14, img15], title: "Ravalement de façade" } },
    { type: 'BeforeAfter', props: { i1: img55, i2: img56, title: "Ravalement de façade" } }
  ],
  "Rénovation des parties communes d'un immeuble": [
    { type: 'BeforeAfter3', props: { i1: img22, i2: img18, i3: img19, i4: img20, i5: img21, title: "Rénovation des parties communes d'un immeuble" } },
    { type: 'BeforeAfter2', props: { i1: img27, i2: img28, i3: img29, title: "Rénovation des parties communes d'un immeuble" } },
    { type: 'ProjectCard', props: { images: [img49], title: "Rénovation des parties communes d'un immeuble" } },
    { type: 'BeforeAfter3', props: { i1: img50, i2: img51, i3: img52, i4: img53, i5: img54, title: "Rénovation des parties communes d'un immeuble" } }
  ],
  "Amenagement extérieur": [
    { type: 'ProjectCard', props: { images: [img57, img58, img59, img60, img61, img62], title: "Amenagement extérieur" } }
  ],
  "Maçonnerie": [
    { type: 'ProjectCard', props: { images: [img67, img68, img69, img70, img71], title: "Maçonnerie" } }
  ],
  "Toiture": [
    { type: 'ProjectCard', props: { images: [img72, img73, img74, img75], title: "Toiture" } }
  ],
  "Placo": [
    { type: 'ProjectCard', props: { images: [img76, img77, img78, img79, img80, img81], title: "Placo" } }
  ],
  "Rénovation clé en main": [
    { type: 'ProjectCard', props: { images: [img1, img2, img3, img4, img5, img6], title: "Rénovation Pavillon H au CHU Lyon Edouard Herriot" } },
    { type: 'ProjectCard', props: { images: [img43, img44], title: "Rénovation de cuisune moderne" } }
  ],
  "Construction": [
    { type: 'ProjectCard', props: { images: [img63, img64, img65, img66], title: "Chantier de construction" } }
  ],
  "Peinture": [
    { type: 'ProjectCard', props: { images: [img1, img2, img3, img4, img5, img6], title: "Rénovation Pavillon H au CHU Lyon Edouard Herriot" } }
  ]
};

// Service details data
const serviceDetails = {
  "Maçonnerie": {
    title: "Maçonnerie",
    icon: "🧱",
    description: "Nos experts en maçonnerie réalisent tous types de travaux de construction et de rénovation : murs, cloisons, cheminées, agrandissements. Nous utilisons des matériaux de qualité pour garantir la solidité et la durabilité de vos ouvrages.",
    services: [
      "Construction de murs et cloisons",
      "Rénovation de façades",
      "Agrandissements et extensions",
      "Réparation de fissures",
      "Travaux de ravalement"
    ]
  },
  "Toiture": {
    title: "Toiture",
    icon: "🏠",
    description: "Nous intervenons pour tous vos besoins en toiture : réparation,  isolation. Notre équipe qualifiée assure l'étanchéité et l'isolation de votre toit pour votre confort et votre sécurité.",
    services: [
      "Réparation de toiture",
      "Isolation de toiture",
      "Pose de tuiles et ardoises",
      "Traitement anti-mousse",
      "Installation de velux"
    ]
  },
  "Placo": {
    title: "Placo",
    icon: "🧰",
    description: "Spécialistes en placo-plâtre, nous réalisons vos cloisons, doublages et plafonds suspendus. Nous assurons également l'isolation thermique et phonique pour améliorer votre confort au quotidien.",
    services: [
      "Pose de cloisons en placo",
      "Doublage de murs",
      "Plafonds suspendus",
      "Isolation thermique et phonique",
      "Enduits et finitions",
      "Réalisation de niches et placards"
    ]
  },
  "Électricité": {
    title: "Électricité",
    icon: "⚡",
    description: "Nous assurons une installation électrique fiable, conforme aux normes en vigueur et pensée pour votre confort et vos besoins du quotidien. De la rénovation complète à la mise aux normes.",
    services: [
      "Installation électrique complète",
      "Mise aux normes",
      "Tableau électrique",
      "Éclairage et prises",
      "Domotique",
      "Dépannage électrique"
    ]
  },
  "Plomberie": {
    title: "Plomberie",
    icon: "🔧",
    description: "Nos spécialistes interviennent pour rénover ou installer votre plomberie avec sérieux et qualité. De la réparation à l'installation complète, nous répondons à tous vos besoins.",
    services: [
      "Installation sanitaire",
      "Dépannage et réparation",
      "Pose de robinetterie",
      "Installation de chauffe-eau",
      "Réseau d'eau et évacuation"
    ]
  },
  "Revêtement de sol": {
    title: "Revêtement de sol",
    icon: "🏗️",
    description: "Du carrelage au parquet, en passant par le vinyle et le lino, nous posons tous types de revêtements de sol pour un rendu impeccable et durable.",
    services: [
      "Pose de carrelage",
      "Pose de parquet",
      "Revêtement vinyle et lino",
      "Rénovation de sols",
      "Ragréage et préparation",
      "Finitions et joints"
    ]
  },
  "Peinture": {
    title: "Peinture",
    icon: "🖌️",
    description: "Nous réalisons tous vos travaux de peinture intérieure et extérieure : rafraîchissement, décoration, finitions. Notre équipe vous conseille sur les couleurs et les produits adaptés pour un résultat durable et soigné.",
    services: [
      "Peinture intérieure",
      "Peinture extérieure et façade",
      "Préparation des supports (enduit, ponçage)",
      "Pose de papiers peints",
      "Finitions et décoration",
      "Conseil en couleurs et produits"
    ]
  },
  "Ravalement de façade": {
    title: "Ravalement de façade",
    icon: "🎨",
    description: "Nous redonnons un aspect neuf à votre façade grâce à nos travaux de ravalement. Nettoyage, réparation, enduit et peinture : nous transformons l'apparence de votre bâtiment tout en préservant sa structure.",
    services: [
      "Nettoyage de façade",
      "Réparation des fissures",
      "Application d'enduit",
      "Peinture de façade",
      "Isolation thermique par l'extérieur (ITE)",
      "Rénovation complète de façade"
    ]
  },
  "Rénovation clé en main": {
    title: "Rénovation clé en main",
    icon: "🔨",
    description: "Nous prenons en charge votre projet de rénovation de A à Z : de la conception à la livraison, en coordonnant tous les corps de métier pour un résultat parfait.",
    services: [
      "Rénovation complète",
      "Coordination des travaux",
      "Suivi de chantier",
      "Gestion des délais",
      "Respect du budget",
      "Livraison clé en main"
    ]
  },
  "Extension": {
    title: "Extension",
    icon: "📐",
    description: "Nous redonnons vie à vos espaces supplémentaires : extensions, garages ou granges deviennent des lieux utiles et harmonieux, parfaitement intégrés à votre habitation.",
    services: [
      "Extension de maison",
      "Aménagement de garage",
      "Rénovation de grange",
      "Surélévation",
      "Création de pièces supplémentaires",
      "Permis de construire et démarches"
    ]
  },
  "Salle de bain clé en main": {
    title: "Salle de bain clé en main",
    icon: "🛁",
    description: "Besoin de renouveau ? Nous repensons entièrement votre salle de bain pour allier esthétique et fonctionnalité. De la conception à la pose, nous gérons tout pour vous.",
    services: [
      "Conception sur mesure",
      "Pose de sanitaires",
      "Carrelage et faïence",
      "Plomberie complète",
      "Électricité et éclairage",
      "Livraison clé en main"
    ]
  },
  "Construction": {
    title: "Construction",
    icon: "🏛️",
    description: "Nous réalisons tous vos projets de construction : maisons individuelles, extensions, surélévations. Notre équipe expérimentée vous accompagne de la conception à la livraison, en respectant les normes et les délais.",
    services: [
      "Construction de maisons individuelles",
      "Extensions et agrandissements",
      "Surélévations",
      "Fondations et gros œuvre",
      "Permis de construire et démarches",
      "Suivi de chantier complet"
    ]
  }
};

const ServicePage = () => {
  const { serviceName } = useParams();
  const history = useHistory();
  const decodedName = decodeURIComponent(serviceName);
  const service = serviceDetails[decodedName];

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    if (!service) {
      // If service not found, redirect to home
      history.push('/');
    }
  }, [service, history]);

  if (!service) {
    return null;
  }

  return (
    <div className="service-page">
      <Navigation />
      <div className="service-page-content">
        <div className="container">
          <br/>
          <br/>

          <button 
            className="service-page-back"
            onClick={() => history.push('/')}
          >
            ← Retour à l'accueil
          </button>
          
          <div className="service-page-detail">
            <div className="service-page-header">
              <span className="service-page-icon">{service.icon}</span>
              <h1 className="service-page-title">{service.title}</h1>
            </div>

            <p className="service-page-description">{service.description}</p>

            <div className="service-page-services">
              <h2>Nos prestations :</h2>
              <ul className="service-page-list">
                {service.services.map((item, index) => (
                  <li key={index}>
                    <span className="service-check">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {serviceImages[decodedName] && serviceImages[decodedName].length > 0 && (
              <div className="service-page-gallery">
                <h2>Nos réalisations</h2>
                <div className="service-gallery-grid">
                  {serviceImages[decodedName].map((item, idx) => (
                    <div key={idx} className="service-gallery-item">
                      {item.type === 'ProjectCard' && <ProjectCard {...item.props} />}
                      {item.type === 'BeforeAfter' && <BeforeAfter {...item.props} />}
                      {item.type === 'BeforeAfter2' && <BeforeAfter2 {...item.props} />}
                      {item.type === 'BeforeAfter3' && <BeforeAfter3 {...item.props} />}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="service-page-cta">
              <a 
                href="/#Devis" 
                className="service-cta-button"
                onClick={(e) => {
                  e.preventDefault();
                  history.push('/#Devis');
                  setTimeout(() => {
                    const element = document.querySelector('#Devis');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }, 200);
                }}
              >
                Demander un devis gratuit
              </a>
            </div>
          </div>
        </div>
      </div>
      <Contact2 />
    </div>
  );
};

export default ServicePage;

